import { render, staticRenderFns } from "./PositionedPins.vue?vue&type=template&id=1079f814&scoped=true&"
import script from "./PositionedPins.vue?vue&type=script&lang=js&"
export * from "./PositionedPins.vue?vue&type=script&lang=js&"
import style0 from "./PositionedPins.vue?vue&type=style&index=0&id=1079f814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079f814",
  null
  
)

export default component.exports